'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import React from 'react';
import styles from './Tab.module.scss';

interface Tab {
  title: string;
  slug?: string;
  handleClick: React.MouseEventHandler<HTMLAnchorElement>;
  handleKeyPress: React.KeyboardEventHandler<HTMLAnchorElement>;
  isActive: boolean;
  onDefaultTab: boolean;
  index: number;
}

const Tab: React.FC<Tab> = ({title, slug, handleClick, handleKeyPress, isActive, index, onDefaultTab}) => {
    return (
      <li role={'presentation'} data-sentry-component="Tab" data-sentry-source-file="Tab.tsx">
        <a
          id={`tab${index}`}
          aria-selected={(isActive && !onDefaultTab) ? 'true': undefined}
          className={`${styles.tab_link} ${isActive && styles.is_active}`}
          href={slug ? `#${slug}` : `#section${index}`}
          onClick={handleClick}
          onKeyDown={handleKeyPress}
          tabIndex={!isActive ? -1 : undefined}
          role={'tab'}
          >
            {title}
        </a>
      </li>
    );
}

export default Tab;
